import { AutocompleteRenderInputParams } from '@mui/material';
import { Autocomplete, Input } from '@trackman/web-shared-components';
import { ReactComponent as DropdownIcon } from 'components/icons/dropdownIcon.svg';
import { ISelectOption } from 'interfaces/ui/ISelectOption';
import React, { ClassAttributes } from 'react';
import { ValueType } from 'react-select/lib/types';
import { CustomDescription, CustomSelectContainer } from './CustomSelectStyles';

export declare type OptionType = {
  label: string | number;
  value: string | number;
  disabled?: boolean;
};

type AutocompleteSelectChange = (_1: React.SyntheticEvent, _2: any, _3: any, newValueOption: any) => void;
type OnSelectChange = (value: ValueType<OptionType>) => void;

export declare type CustomSelectProps = ClassAttributes<OptionType> & {
  placeholder?: string;
  label?: string;
  value?: string | undefined;
  emptyOption?: ISelectOption;
  options: ISelectOption[];
  isDisabled?: boolean;
  isSorted?: boolean;
  onSelectChange: OnSelectChange | AutocompleteSelectChange;
  isOptionEqualToValue?: (a: ISelectOption, b: ISelectOption) => boolean;
  disableClearable?: boolean;
  error?: boolean;
};
export const CustomSelect: React.FC<CustomSelectProps> = (props) => {
  const {
    placeholder,
    label,
    value,
    onSelectChange,
    emptyOption,
    options,
    isDisabled,
    isSorted,
    isOptionEqualToValue,
    disableClearable,
    key,
    ref,
    ...rest
  } = props;

  const getOptions = (): ISelectOption[] => {
    const opts = isSorted === true ? options.sort((a, b) => (a.label > b.label ? 1 : -1)) : options;
    return emptyOption ? [emptyOption, ...opts] : opts;
  };

  return (
    <CustomSelectContainer {...rest}>
      <Autocomplete
        popupIcon={<DropdownIcon />}
        value={value}
        onChange={onSelectChange as any}
        options={getOptions()}
        width='440px'
        disabled={isDisabled}
        renderInput={(params: AutocompleteRenderInputParams) => <Input {...params} label={placeholder} />}
        isOptionEqualToValue={isOptionEqualToValue}
        disableClearable={disableClearable}
      />
      <CustomDescription>{label}</CustomDescription>
    </CustomSelectContainer>
  );
};
